import { FC } from 'react';
import { PageTitle, PageLink } from '../../../../rbts/layout/core';
import { View } from './components/View';

const RecintosPage: FC = () => {
  const breadcrumbs: Array<PageLink> = [
    { title: 'Boletera', path: '/boletera/recintos/', isActive: false },
  ];

  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs}>Recintos</PageTitle>
      <View />
    </>
  );
};

export { RecintosPage };
